import { withWindow } from '@shared/utils/withWindow';

/**
 * True when the browser implements CSS scroll anchoring (`overflow-anchor` — Chrome,
 * Firefox, Edge; NOT Safari).
 *
 * Anchoring is the only position-keeping mechanism that cannot register a layout shift:
 * it adjusts the scroll offset *inside* the layout pass and is CLS-exempt by spec. Any JS
 * alternative must measure the growth first, and that measurement forces the layout pass
 * in which Chrome records the shift — correcting afterwards, even pre-paint, cannot
 * retract it (a deterministic 0.97 shift survived synchronous MutationObserver- and
 * ResizeObserver-timed corrections for exactly this reason).
 *
 * Anchoring is only safe here because candidacy is deterministic: non-target sections and
 * the footer carry `overflow-anchor: none` (see `scrollAnchorCandidacy` in
 * LayoutAloha.styles), so the deep-link target is the only node the browser may pin.
 * Where anchoring is unsupported, the JS scroll keepers remain the fallback. PRNT-4799.
 */
export const isScrollAnchoringSupported = (): boolean => withWindow(global => 'overflowAnchor' in global.document.documentElement.style, false);
